import WallOutlineModel from '@/editor/entities/2d/wallOutlineModel';
import { globalStores } from '@/editor/stores';
import { EEntityType } from '@/editor/types';
import { genPolygonHash } from '@/editor/utils/hash';

export class WallOutlineManager {
  private _wallOutlineModel = new WallOutlineModel();
  private _hash: number = 0;

  update() {
    const hiddenWallSet = globalStores.visibilityStore.getHiddenEntitiesIdsByEntityType(EEntityType.Wall);
    const edges: Parameters<WallOutlineModel['update']>[0]['edges'] = globalStores.connectedWallOutlines
      .flatMap((outline) => outline.edges)
      .filter((edge) => !hiddenWallSet.has(edge.wallId));

    // 计算hash：需覆盖每条边的完整几何(起点/终点/弧心/方向)。
    // 只按 start 点算会漏掉终点与弧度信息：如两段共圆半弧共端点围成整圆时，
    // 新增墙后边集已变但起点哈希可能不变，导致 update 被跳过、轮廓不重绘(存盘重开才正常)。
    const _hash = genPolygonHash(
      edges.map((edge) => {
        if (!edge.center) {
          return edge.start;
        } else {
          return { x: edge.start.x, y: edge.start.y, center: edge.center, clockwise: edge.clockwise };
        }
      })
    );

    if (_hash !== this._hash) {
      this._hash = _hash;
      this._wallOutlineModel.update({ edges });
    }
  }

  dispose() {
    this._wallOutlineModel.dispose();
  }
}
